import { useEffect } from "react";

export default function App() {
  useEffect(() => {
    window.location.replace(`${process.env.REACT_APP_BACKEND_URL}/api/k/`);
  }, []);
  return <p style={{ fontFamily: "system-ui", padding: 24 }}>Chargement de DDSPLANNER…</p>;
}
